import { ErrorOperations } from "../../shonascript/Operations/errorOperations"
import { VariableOperations } from "../../shonascript/Operations/variables"
import { ErrorOperationsDhaga } from "./errorOperations"

export const StyleOperations = {
  isStyle: arg => {
    return (
      StyleOperations.isColor(arg) ||
      StyleOperations.isTextColor(arg) ||
      StyleOperations.isWidth(arg) ||
      StyleOperations.isHeight(arg) ||
      StyleOperations.isJustifyContent(arg) ||
      StyleOperations.isBorderRadius(arg) ||
      StyleOperations.isBorderWidth(arg) ||
      StyleOperations.isBorderColor(arg) ||
      StyleOperations.isBoxShadow(arg) ||
      StyleOperations.isBackgroundImage(arg) ||
      StyleOperations.isFontSize(arg) ||
      StyleOperations.isFontWeight(arg) ||
      StyleOperations.isRotate(arg) ||
      StyleOperations.isHide(arg)
    )
  },

  isColor: arg => {
    let colorMatcher = /c-/
    return colorMatcher.test(arg)
  },

  color: arg => {
    let colorMatcher = /c-/
    let color = arg.replace(colorMatcher, "").trim()
    if (/ss/.test(color)) {
      return `background-color: transparent; ${arg.trim()}:0;`
    } else {
      return color
    }
  },

  isTextColor: arg => {
    let colorMatcher = /ms-c-/
    return colorMatcher.test(arg)
  },

  textColor: arg => {
    let colorMatcher = /ms-c-/
    let color = arg.replace(colorMatcher, "").trim()
    if (/ss/.test(color)) {
      return `color: gray; ${arg.trim()}:0;`
    } else {
      return color
    }
  },

  isWidth: arg => {
    let matcher = /kf-/
    return matcher.test(arg)
  },

  width: (readLinesOriginal, errors, line, arg) => {
    let width = arg.replace(/kf-/, "").trim()
    if (/ss/.test(width)) {
      return `width: 10vw; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(width)
        console.log(num)
        if (!isNaN(num) && num < 11) {
          return `width: ${10 * num}vw`
        } else {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "kufara kwakaita box"
          )
        }
      } catch (e) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "kufara kwakaita box"
        )
      }
    }
  },

  isHeight: arg => {
    let matcher = /kr-/
    return matcher.test(arg)
  },

  height: (readLinesOriginal, errors, line, arg) => {
    let height = arg.replace(/kr-/, "").trim()
    if (/ss/.test(height)) {
      return `height: 10vw; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(height)
        if (!isNaN(num) && num < 11) {
          return `height: ${10 * num}vw`
        } else {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "kureba kwakaita box"
          )
        }
      } catch (e) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "kureba kwakaita box"
        )
      }
    }
  },

  isJustifyContent: arg => {
    let matcher = /rg-/
    return matcher.test(arg)
  },

  justifyContent: arg => {
    let jc = {
      l: "left",
      r: "right",
      c: "center",
      sp: "space-evenly",
    }
    return `justify-content: ${jc[arg.replace(/rg-/, "")]}`
  },

  textAlign: arg => {
    return `text-align: ${arg.replace(/p-/, "")}`
  },

  //------------ border radius ---------
  isBorderRadius: arg => {
    let matcher = /kn-/
    return matcher.test(arg)
  },

  borderRadius: (readLinesOriginal, errors, line, arg) => {
    let radius = arg.replace(/kn-/, "").trim()

    if (/ss/.test(radius)) {
      return `border-radius: 0px; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(radius)
        if (!Number.isNaN(num)) {
          if (num >= 10) {
            return `border-radius: ${num * 10}%`
          } else {
            return `border-radius: ${num * 10}px`
          }
        } else {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "kona ye box"
          )
        }
      } catch (e) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "kona ye box"
        )
      }
    }
  },

  // ----------- border width ------------
  isBorderWidth: arg => {
    let matcher = /mg-sz-/
    return matcher.test(arg)
  },

  borderWidth: (readLinesOriginal, errors, line, arg) => {
    let width = arg.replace(/mg-sz-/, "").trim()
    if (/ss/.test(width)) {
      return `border-width: 0px; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(width)
        if (!isNaN(num)) {
          if (num >= 10) {
            return `border-width: ${10}px`
          } else {
            return `border-width: ${num}px`
          }
        } else {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "kufara kwakaita muganhu"
          )
        }
      } catch (e) {
        // throw an error if there are possible edge cases here
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "kufara kwakaita muganhu"
        )
      }
    }
  },
  // ------------- border color ---------
  isBorderColor: arg => {
    let matcher = /mg-c-/
    return matcher.test(arg)
  },

  borderColor: arg => {
    let colorMatcher = /mg-c-/
    let color = arg.replace(colorMatcher, "").trim()
    if (/ss/.test(color)) {
      return `border-color: gray; ${arg.trim()}:0;`
    } else {
      return color
    }
  },

  // ------------ box shadow -----------------
  isBoxShadow: arg => {
    let matcher = /mv-/
    return matcher.test(arg)
  },

  boxShadow: (readLinesOriginal, errors, line, arg) => {
    let shadow = arg.replace(/mv-/, "").trim()
    if (/ss/.test(shadow)) {
      return `box-shadow: 0px; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(shadow)
        if (!isNaN(num)) {
          if (num >= 10) {
            return `box-shadow: ${10}px ${10}px 8px rgba(0,0,0,0.1);`
          } else {
            return `box-shadow: ${num}px ${num}px 8px rgba(0,0,0,0.1);`
          }
        } else {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "size yemunvuri"
          )
        }
      } catch (e) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "size yemunvuri"
        )
      }
    }
  },

  // TODO: deal with the image errors here
  isBackgroundImage: arg => {
    let matcher = /\bpic-/
    return matcher.test(arg)
  },

  backgroundImage: (arg, imageRefs) => {
    let matcher = /\bpic-/
    let imageRef = arg.replace(matcher, "").trim()

    if (/ss/.test(arg)) {
      return `background-image: url(); ${arg.trim()}:0; background-position: center; background-size: cover;`
    } else {
      try {
        let imageRefNum = Number(imageRef)
        console.log(imageRefNum)
        console.log(!Number.isNaN(imageRefNum))
        if (!Number.isNaN(imageRefNum)) {
          let storagePics = localStorage.getItem("dhaga-pictures")
          storagePics = JSON.parse(storagePics)
          let storagePicsNum = storagePics.length
          let chosenIndex = imageRefNum
          return `background-image:url('${storagePics[chosenIndex - 1]}');`
        }
      } catch (e) {
        console.log(" should throw an error", e)
      }
    }
  },

  // ----------- font size ----------------
  isFontSize: arg => {
    let matcher = /\bms-sz-/
    return matcher.test(arg)
  },

  fontSize: (readLinesOriginal, errors, line, arg) => {
    let matcher = /\bms-sz-/
    let size = arg.replace(matcher, "").trim()

    if (/ss/.test(size)) {
      return `font-size: 0px; ${arg.trim()}:0`
    } else {
      try {
        let num = Number(size)
        if (!isNaN(num) && num < 11) {
          return `font-size: ${10 * num}px`
        } else {
          // TODO: throw error here
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            arg,
            "size yemashoko"
          )
        }
      } catch (e) {
        // throw an error if there are possible edge cases here
      }
    }
  },

  isFontWeight: arg => {
    let matcher = /\bms-uk-/
    return matcher.test(arg)
  },

  fontWeight: (readLinesOriginal, errors, line, arg) => {
    let matcher = /\bms-uk-/
    let fontWeights = ["Thin", "", "Medium", "Bold"]
    let ogArg = arg
    arg = arg.replace(matcher, "").trim()

    if (/ss/.test(arg)) {
      return `font-weight: 0px; ${ogArg.trim()}:0`
    } else {
      try {
        let weightRef = Number(arg)
        if (Number.isNaN(weightRef) || weightRef > 4) {
          ErrorOperationsDhaga.checkDimension(
            readLinesOriginal,
            errors,
            line,
            ogArg,
            "ukobvu hwemashoko"
          )
          console.log(arg)
        } else {
          return `font-family: Inter${fontWeights[weightRef - 1]}`
        }
      } catch (e) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          ogArg,
          "ukobvu hwemashoko"
        )
      }
    }
  },

  // text Align
  isRotate: arg => {
    let matcher = /\btn-/
    return matcher.test(arg)
  },

  rotate: (readLinesOriginal, errors, line, arg) => {
    let matcher = /\btn-/
    let ogArg = arg
    arg = arg.replace(matcher, "").trim()
    if (/ss/.test(arg)) {
      return `transform: rotate(); ${ogArg.trim()}:0`
    } else {
    try {
      let num = Number(arg)

      if (Number.isNaN(num) || num > 10) {
        ErrorOperationsDhaga.checkDimension(
          readLinesOriginal,
          errors,
          line,
          arg,
          "kutendenderera kwe box"
        )
      } else {
        return `transform: rotate(${num * 30}deg);`
      }
    } catch (e) {
      ErrorOperationsDhaga.checkDimension(
        readLinesOriginal,
        errors,
        line,
        arg,
        "kutendenderera kwe box"
      )
    }
  }
  },

  isHide: arg => {
    let matcher = /\bv-/
    return matcher.test(arg)
  },

  hide: arg => {
    let matcher = /\bv-/
    let display = arg.replace(matcher, "").trim()
    if (/ss/.test(display)) {
      return `display:flex; ${arg}:0;`
    } else {
      if (display == "hongu") {
        return `display: none;`
      } else {
        return `display: flex;`
      }
    }
  },
}

const spans = []
const inputs = []
const storageImages = []

export const runStyleOperations = (
  readLinesOriginal,
  readlines,
  errors,
  classNames
) => {
  for (let i = 0; i < readlines.length; i++) {
    let x = readlines[i]
    // styles are seen before the colon
    let stylesString =
      "background-color: transparent; width: 10vw; min-height: 10vw;border-style: solid; border-width:0px; display: flex; flex-wrap: wrap; align-items: center; background-position: center; background-size:cover;"
    if (/</.test(x) && !/>/.test(x)) {
      x = x.replace(/:/, "") //ignore the colons

      let lineSplit = x.split(" ")

      if (/button/.test(x)) {
        stylesString =
          "background-color: transparent;  display: flex; align-items: center; justify-content: space-evenly; min-height: 10vw;"
      }

      for (let i = 1; i < lineSplit.length; i++) {
        let currentWord = lineSplit[i].trim()
        let isStyle = StyleOperations.isStyle(currentWord)

        if (isStyle) {
          // --------------------- background image ------------------
          if (StyleOperations.isBackgroundImage(currentWord)) {
            stylesString += `${StyleOperations.backgroundImage(
              currentWord,
              storageImages
            )}`
            x = x.replace(currentWord, "")
          }
          // --------------- border color --------------
          else if (StyleOperations.isBorderColor(currentWord)) {
            ErrorOperationsDhaga.checkColor(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )

            if (/ss/.test(currentWord)) {
              stylesString += `${StyleOperations.borderColor(currentWord)};`
            } else {
              stylesString += `border-color: ${StyleOperations.borderColor(
                currentWord
              )};`
            }

            x = x.replace(currentWord, "")
          } else if (StyleOperations.isTextColor(currentWord)) {
            ErrorOperationsDhaga.checkColor(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )
            if (/ss/.test(currentWord)) {
              stylesString += `${StyleOperations.textColor(currentWord)}`
            } else {
              stylesString += "color: black;"
              stylesString = stylesString.split(";")
              stylesString = stylesString.map(x => {
                if (x == "color: black") {
                  x = `color: ${StyleOperations.textColor(currentWord)}`
                  return x
                } else {
                  return x
                }
              })

              stylesString = stylesString.join(";")
            }

            x = x.replace(currentWord, "")
          }
          // ------------------- color -------------
          else if (StyleOperations.isColor(currentWord)) {
            ErrorOperationsDhaga.checkColor(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )

            if (/ss/.test(currentWord)) {
              stylesString = stylesString.replace(
                "background-color: transparent;",
                ``
              )
              stylesString += `${StyleOperations.color(currentWord)}`
            } else {
              stylesString = stylesString.replace(
                "background-color: transparent",
                `background-color: ${StyleOperations.color(currentWord)}`
              )
            }
            x = x.replace(currentWord, "") //remove the style word from the original string
          } // ------------------ width --------------
          else if (StyleOperations.isWidth(currentWord)) {
            if (/button/.test(x) || /\bmn[123456]+/.test(x)) {
              stylesString += "width: 10vw;"
            }
            stylesString = stylesString.replace(
              "width: 10vw",
              `${StyleOperations.width(
                readLinesOriginal,
                errors,
                x,
                currentWord
              )}`
            )
            x = x.replace(currentWord, "") //remove the style word from the original string
          }
          //------------------- Justify Content ---------------
          else if (StyleOperations.isJustifyContent(currentWord)) {
            if (/<mn[123456]+/.test(x)) {
              // should be text align
              stylesString += `${StyleOperations.textAlign(currentWord)};`
            } else {
              stylesString += `${StyleOperations.justifyContent(currentWord)};`
            }

            x = x.replace(currentWord, "") //remove the style word from the original string
          }
          // ---------------- border radius ---------------
          else if (StyleOperations.isBorderRadius(currentWord)) {
            stylesString += `${StyleOperations.borderRadius(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )};`
            x = x.replace(currentWord, "") //remove the style word from the original string
          }
          //------------------- border width ----------------
          else if (StyleOperations.isBorderWidth(currentWord)) {
            stylesString = stylesString.replace(
              "border-width:0px",
              `${StyleOperations.borderWidth(
                readLinesOriginal,
                errors,
                x,
                currentWord
              )}`
            )
            x = x.replace(currentWord, "")
          } else if (StyleOperations.isBoxShadow(currentWord)) {
            stylesString += `${StyleOperations.boxShadow(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )};`
            x = x.replace(currentWord, "")
          }

          // ------------------ font size -------------
          else if (StyleOperations.isFontSize(currentWord)) {
            stylesString += `${StyleOperations.fontSize(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )};`
            x = x.replace(currentWord, "")
          }
          // --------------------- font weight -------------
          else if (StyleOperations.isFontWeight(currentWord)) {
            stylesString += `${StyleOperations.fontWeight(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )};`
            x = x.replace(currentWord, "")
          }
          // ---------------- height ------------
          else if (StyleOperations.isHeight(currentWord)) {
            if (/\bmn[123456]+/.test(x)) {
              stylesString += "height: 10vw;"
            } else {
              stylesString = stylesString.replace(
                "min-height: 10vw",
                `${StyleOperations.height(
                  readLinesOriginal,
                  errors,
                  x,
                  currentWord
                )}`
              )
              x = x.replace(currentWord, "") //remove the style word from the original string
            }
          }

          // ----------------- Rotate ------------
          else if (StyleOperations.isRotate(currentWord)) {
            stylesString += `${StyleOperations.rotate(
              readLinesOriginal,
              errors,
              x,
              currentWord
            )}`
            x = x.replace(currentWord, "")
          } else if (StyleOperations.isHide(currentWord)) {
            stylesString = stylesString.replace(/display\:[\w\s]+\;/, "")
            stylesString += `${StyleOperations.hide(currentWord)}`
            x = x.replace(currentWord, "")
          }
        } else {
        }
      }

      if (/\bh[123456]+/.test(x)) {
        stylesString = stylesString.replace("width: 10vw", "min-width:10w")
        stylesString += `font-family:'InterBold';`
      }

      // remove the tags, whatever is left should be the name of claaName

      let tagMatcher = /<\w+/
      let tagClass = x.replace(tagMatcher, "").trim()

      if (tagClass) {
        classNames.push(tagClass)
        if (VariableOperations.isVariableValid(tagClass) !== "checkVariable") {
          ErrorOperations.variableWronglyWritten(
            readLinesOriginal,
            errors,
            x,
            tagClass
          )
        }

        if (/span/.test(x)) {
          //collect the spans needed in the DOM operations
          if (!spans.includes(tagClass)) {
            // push if not in already
            spans.push(tagClass)
          }
        } else if (/input/.test(x)) {
          if (!inputs.includes(tagClass)) {
            inputs.push(tagClass)
          }
        }
        x = x.replace(tagClass, "")
        x += `class="${tagClass}" `
      }

      x += `style="${stylesString}">`
      readlines[i] = x
    }
  }
  localStorage.setItem("dhaga-spans", spans)
  localStorage.setItem("dhaga-inputs", inputs)
  return readlines
}
